export const clientsField = [
  {
    name: "customerName",
    label: "Customer Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "phoneNumber",
    label: "Phone Number *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "email",
    label: "Email *",
    type: "text",
    gridColumn: "span 2",
    required: false,
  },
];
